export default "__VITE_ASSET__C9J2NlRO__"